import { CsvPayload } from '../../common/models/CsvPayload';

export class ProjectCsvData {
  constructor(private readonly inventory: CsvPayload, private readonly issues: CsvPayload) {}

  getInventory() {
    return this.inventory;
  }

  getIssues() {
    return this.issues;
  }
}
